import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/',
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.userToken
            if (token) {
                // include token in req header
                headers.set('Authorization', `Token ${token}`);
                headers.set('X-Csrftoken', document.cookie.csrftoken);
                return headers
            }
        },
    }),
    tagTypes: ['info', 'neighbours', 'parking'],
    endpoints: (builder) => ({
        getUserDetails: builder.query({
            query: () => ({
                url: '/getInfo/',
                method: 'GET',
            }),
            providesTags: () => ['info']
        }),
        getUserNeighbours: builder.query({
            query: () => ({
                url: '/getNeighbours/',
                method: 'GET',
            }),
            providesTags: () => ['neighbours']
        }),
        getParkingAccount: builder.query({
            query: () => ({
                url: '/parking/account/',
                method: 'GET',
            }),
            providesTags: () => ['parking']
        }),
        getLiqpayForm: builder.mutation({
            query: (amount) => ({
                url: '/liqpay/',
                method: 'POST',
                body: {amount},
                responseHandler: (response) => response.text()
            }),
        }),
        getParkingTopupLiqpayForm: builder.mutation({
            query: (amount) => ({
                url: '/parking/liqpay/topup/',
                method: 'POST',
                body: {amount},
                responseHandler: (response) => response.text()
            }),
        }),
        payParkingBillsFromBalance: builder.mutation({
            query: (bill_ids) => ({
                url: '/parking/pay-from-balance/',
                method: 'POST',
                body: { bill_ids },
            }),
            invalidatesTags: (result, error) => error ? [] : ['parking', 'info']
        }),
        updateUserDetails: builder.mutation({
            query: (body) => ({
                url: '/update/',
                method: 'PUT',
                body
            }),
            invalidatesTags: () => ['info', 'neighbours']
        }),
        updateParkingAccount: builder.mutation({
            query: (body) => ({
                url: '/parking/account/update/',
                method: 'POST',
                body,
            }),
            invalidatesTags: () => ['parking', 'info']
        }),
        updateParkingAccessData: builder.mutation({
            query: (body) => ({
                url: '/parking/account/access-data/',
                method: 'POST',
                body,
            }),
            invalidatesTags: () => ['parking', 'info']
        }),
        assignParkingRenter: builder.mutation({
            query: (body) => ({
                url: '/parking/renter/',
                method: 'POST',
                body,
            }),
            invalidatesTags: () => ['parking', 'info']
        }),
        verifyUserCode: builder.mutation({
            query: (values) => ({
                url: '/verify/',
                method: 'POST',
                body: values,
            }),
            invalidatesTags: () => ['info', 'neighbours', 'parking']
        }),
        buyKeychain: builder.mutation({
            query: () => ({
                url: '/keychain/',
                method: 'POST',
                body: {},
            }),
            invalidatesTags: () => ['info']
        }),
    }),
});

export const { 
    useGetUserDetailsQuery, 
    useGetUserNeighboursQuery, 
    useGetParkingAccountQuery,
    useUpdateUserDetailsMutation, 
    useGetLiqpayFormMutation, 
    useGetParkingTopupLiqpayFormMutation,
    usePayParkingBillsFromBalanceMutation,
    useUpdateParkingAccountMutation,
    useUpdateParkingAccessDataMutation,
    useAssignParkingRenterMutation,
    useVerifyUserCodeMutation, 
    useBuyKeychainMutation,
    util 
} = authApi
